module.exports = __webpack_public_path__ + "static/pic01-f7c500d0c7ce97f4fa08f6f797eaf142.jpg";